import { useState } from "react";

export const useTableActions = (tableApis, onTableUpdate) => {
  const [viewData, setViewData] = useState(null);
  const [showViewMore, setShowViewMore] = useState(false);
  const [showEdit, setShowEdit] = useState(false);
  const [editData, setEditData] = useState(null);
  const [dropdownIndex, setDropdownIndex] = useState(null);

  const handleActionClick = async (action, row, headers) => {
    if (action === "View") {
      try {
        console.log("row data", row);
        setViewData(row);
        setShowViewMore(true);
      } catch (err) {
        console.error("Error fetching entry details:", err);
      }
    } else if (action === "Edit") {
      try {
        // const response = await tableApis.getById(row.id);
        console.log("row data", row);
        console.log("headers", headers);

        // Filter row data to only include keys that match headers
        // const filteredData = {};
        // if (headers && Array.isArray(headers)) {
        //   headers.forEach((header) => {
        //     if (row.hasOwnProperty(header.key)) {
        //       filteredData[header.key] = row[header.key];
        //     }
        //   });
        //   // Preserve the id for reference
        //   if (row.id) filteredData.id = row.id;

        //   console.log("Filtered data for edit:", filteredData);
        // } else {
        //   // If headers not provided, use original row data
        //   Object.assign(filteredData, row);
        // }

        setEditData(row);
        setShowEdit(true);
      } catch (err) {
        console.error("Error fetching entry for edit:", err);
      }
    } else if (action === "Delete") {
      try {
        await tableApis.deleteById(row.applicant_id);
        if (onTableUpdate) onTableUpdate();
      } catch (err) {
        console.error("Error deleting entry:", err);
      }
    }
  };

  const toggleDropdown = (index) => {
    setDropdownIndex(index === dropdownIndex ? null : index);
  };

  const closeDropdown = () => setDropdownIndex(null);

  return {
    viewData,
    showViewMore,
    showEdit,
    editData,
    dropdownIndex,
    handleActionClick,
    toggleDropdown,
    closeDropdown,
    setShowViewMore,
    setShowEdit,
    setEditData,
    setViewData,
  };
};
